// extracted by mini-css-extract-plugin
module.exports = {"lang-switcher":"LanguageSwitcher_lang-switcher__Vmanb","lang-switch":"LanguageSwitcher_lang-switch__25b-D","en":"LanguageSwitcher_en__2KJXD","ru":"LanguageSwitcher_ru__2HJlv"};